import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnInit } from '@angular/core';

import { SearchNavbarBaseSubformComponent } from '@shared/components/search-layout/search-navbar/search-navbar-base-subform/search-navbar-base-subform.component';

@Component({
  selector: 'app-checkbox-subform',
  templateUrl: './checkbox-subform.component.html',
  styleUrls: ['./checkbox-subform.component.scss'],
})
export class CheckboxSubformComponent
  extends SearchNavbarBaseSubformComponent
  implements OnInit
{
  @Input() override data!: {
    checkboxOptions: Array<string>;
    optionIds?: Array<string>;
    isSingle?: boolean;
    filter?: any;
    optionTitlePrefix?: string;
  };

  override group = this.fb.group({});

  selection = new SelectionModel<string>(true, []);

  override ngOnInit(): void {
    super.ngOnInit();
    this.data.checkboxOptions?.forEach((element: any) => {
      this.group.addControl(element, this.fb.control(null, []));
      if (this.data.filter?.[element]) {
        this.group.controls[element].setValue(this.data.filter[element]);
        this.selection.select(this.data.filter[element]);
      } else if (
        Array.isArray(this.data.filter?.[element]) &&
        this.data.filter?.[element].length > 0
      ) {
        this.data.filter[element].forEach((option: any) => {
          this.group.controls[option].setValue(this.data.filter[option]);
          this.selection.select(this.data.filter[option]);
        });
      }
    });
  }

  override updateValue(filter?: any): void {
    this.clear();
    if (filter) {
      if (
        Array.isArray(filter[this.property]) &&
        filter[this.property]?.length
      ) {
        filter[this.property].forEach((elem: any) => {
          const index = this.data.optionIds?.findIndex(
            (id: string) => id === elem
          );
          this.group.controls[this.data.checkboxOptions?.[index ?? 0]].setValue(
            true
          );
        });
      } else if (filter[this.property] && filter[this.property].length > 0) {
        this.group.controls[filter[this.property]].setValue(true);
      }
    } else {
      this.clear();
    }
  }

  valueChanged(event: boolean, control?: any): void {
    if (event !== null) {
      control !== undefined &&
        !this.data.isSingle &&
        this.selection.toggle(control);

      if (this.data.isSingle && control !== undefined && event !== false) {
        this.selection.selected[0]
          ? this.group.controls[this.selection.selected[0]].setValue(null)
          : '';
        this.selection.clear();
        this.selection.select(control);
      } else if (
        this.data.isSingle &&
        control !== undefined &&
        event === false
      ) {
        this.selection.clear();
      }
      if (this.property) {
        this.store.dispatch(
          this.filterUpdater.trigger({
            filter: {
              [this.property]: this.data.isSingle
                ? this.selection.selected[0] ?? undefined
                : this.selection.selected,
            },
          })
        );
      } else {
        this.data.checkboxOptions?.forEach((element: any) => {
          this.store.dispatch(
            this.filterUpdater.trigger({
              filter: {
                [element]: this.selection.isSelected(element),
              },
            })
          );
        });
      }
    }
  }

  override clear(): void {
    this.selection.clear();
    this.group.reset();
    this.valueChanged(false);
  }
}
